import React from 'react';

import PropTypes from 'prop-types';

//import { FontBase } from 'const';
import MainFont from 'ui/typography/mainFont';

import {
  ChartContainer,
  SubTitle,
  Title,
  WidgetContainerWrapper
} from './style';

const WidgetContainer = ({
  title,
  subtitle,
  children,
  height,
  noShadow,
  fontSize: size,
  subMargin,
  tagLabel
}) => (
  <WidgetContainerWrapper height={height} noShadow={noShadow}>
    {title && (
      <Title>
        <MainFont configuration={{ fontSize: size, fontWeight: 600 }}>
          {title}
        </MainFont>
      </Title>
    )}
    {subtitle && (
      <SubTitle subMargin={subMargin} tagLabel={tagLabel}>
        <MainFont configuration={{ fontSize: 12 }}>{subtitle}</MainFont>
      </SubTitle>
    )}
    <ChartContainer>{children}</ChartContainer>
  </WidgetContainerWrapper>
);

WidgetContainer.defaultProps = {
  fontSize: 16,
  subMargin: 26
};

WidgetContainer.propTypes = {
  fontSize: PropTypes.number,
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  height: PropTypes.number,
  noShadow: PropTypes.bool,
  subMargin: PropTypes.number,
  tagLabel: PropTypes.bool
};

export default WidgetContainer;
